import {api} from "../api.slice";
import {apiEndpoints} from "@/utils/api-endpoints";
import {
    GetInventoryCountRequest,
    GetInventoryCountResponse,
    GetInventoryCountItemsRequest,
    GetInventoryCountItemsResponse,
    GetInventoryCountsRequest,
    GetInventoryCountsResponse,
} from "@/types/inventory-count";

const InventoryCountApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getInventoryCounts: builder.query<
            GetInventoryCountsResponse,
            GetInventoryCountsRequest
        >({
            query: (arg) => ({
                url: apiEndpoints.InventoryCounts.GetInventoryCounts.url,
                method: apiEndpoints.InventoryCounts.GetInventoryCounts.method,
                params: arg,
            }),
            providesTags: ["InventoryCounts"],
        }),

        getInventoryCount: builder.query<
            GetInventoryCountResponse,
            GetInventoryCountRequest
        >({
            query: ({id}) => ({
                url: apiEndpoints.InventoryCounts.GetInventoryCount.url(String(id)),
                method: apiEndpoints.InventoryCounts.GetInventoryCount.method,
            }),
            providesTags: ["InventoryCounts"],
        }),

        getInventoryCountItems: builder.query<
            GetInventoryCountItemsResponse,
            GetInventoryCountItemsRequest
        >({
            query: ({id, page, viewMode, searchText}) => ({
                url: apiEndpoints.InventoryCounts.GetInventoryCountItems.url(String(id)),
                method: apiEndpoints.InventoryCounts.GetInventoryCountItems.method,
                params: {
                    page,
                    viewMode,
                    searchText,
                },
            }),
            providesTags: ["InventoryCounts"],
        }),

        addInventoryCount: builder.mutation<
            unknown,
            { comment?: string }
        >({
            query: ({ comment }) => ({
                url: apiEndpoints.InventoryCounts.AddInventoryCounts.url,
                method: apiEndpoints.InventoryCounts.AddInventoryCounts.method,
                params: {
                    comment,
                },
            }),
            invalidatesTags: ["InventoryCounts"],
        }),

        editInventoryCountItems: builder.mutation<
            unknown,
            {
                id: number | string;
                body: unknown;
            }
        >({
            query: ({id, body}) => ({
                url: apiEndpoints.InventoryCounts.EditInventoryCountItems.url(String(id)),
                method: apiEndpoints.InventoryCounts.EditInventoryCountItems.method,
                body,
            }),
            invalidatesTags: [],
        }),

        deleteInventoryCountItems: builder.mutation<
            unknown,
            number | string
        >({
            query: (id) => ({
                url: apiEndpoints.InventoryCounts.DeleteInventoryCountItems.url(String(id)),
                method: apiEndpoints.InventoryCounts.DeleteInventoryCountItems.method,
            }),
            invalidatesTags: ["InventoryCounts"],
        }),

        finishInventoryCountItems: builder.mutation<
            unknown,
            { id: number | string }
        >({
            query: ({id}) => ({
                url: apiEndpoints.InventoryCounts.FinishInventoryCountItems.url(String(id)),
                method: apiEndpoints.InventoryCounts.FinishInventoryCountItems.method,
            }),
            invalidatesTags: ["InventoryCounts"],
        }),

        restoreInventoryCountItems: builder.mutation<
            unknown,
            number | string
        >({
            query: (id) => ({
                url: apiEndpoints.InventoryCounts.RestoreInventoryCountItems.url(String(id)),
                method: apiEndpoints.InventoryCounts.RestoreInventoryCountItems.method,
            }),
            invalidatesTags: ["InventoryCounts"],
        }),
    }),
});

export const {
    useGetInventoryCountsQuery,
    useGetInventoryCountQuery,
    useGetInventoryCountItemsQuery,
    useAddInventoryCountMutation,
    useEditInventoryCountItemsMutation,
    useDeleteInventoryCountItemsMutation,
    useFinishInventoryCountItemsMutation,
    useRestoreInventoryCountItemsMutation,
} = InventoryCountApi;

export default InventoryCountApi;